<template>
    <div>
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
         <v-card-text>
             <v-container v-if="courseinfo!=null">
                  <v-btn color="primary darken-1" @click="viewQuesBank">View Question Bank</v-btn>
                <v-toolbar dense color="#f5f5f2" max-width = "1500px">

                      <strong>Course Name:</strong>{{courseinfo.crscode}}:{{courseinfo.crsname}}
                      <strong>Question Type</strong>{{qttype.name}}
                </v-toolbar> 
                <br>
                <v-toolbar dense color="#f5f5f2">
                    <center><strong>Add Question</strong></center>
                </v-toolbar>
                <v-divider></v-divider>
                <v-toolbar dense color="#e32d2d">
                    <strong> Question No.{{qno}}</strong>
                </v-toolbar>
             
                <v-simple-table style="border: 1px solid #bdb7b9;">
                    <template v-slot:default>
                        <thead class="alert alert-danger">
                            <tr>
                                <th class="text-left">Unit Section</th>
                                <th class="text-left">Difficulty Type</th>
                                <th class="text-left">Question Satement</th>
                                <th class="text-left">Select Question JPEG Image</th>
                                <th class="text-left">Approve Question</th>
                            </tr>
                            </thead>
                            <tbody>
                                    <tr>
                                        <td>
                                            <v-col cols="12">
                                                <v-autocomplete dense v-model="editedItem.unit" :items="unit_list"  :readonly="editedIndex==-1?false:true" item-text="name" item-value="id"   :filled="editedIndex==0?false:true" :error="errorMsg.unit?true:false" :error-messages="errorMsg.unit?'Required':''" return-object outlined  chips small-chips></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" v-if='editedIndex != -1'>Unit
                                                    <v-autocomplete dense v-model="editedItem.unit" :items="unit_list" item-value="id" itme-text='names'  :error="errorMsg.unit?true:false" :error-messages="errorMsg.unit?'Required':''"></v-autocomplete>
                                            </v-col>
                                        </td>
                                        <td>
                                            <v-col cols="12">
                                                <v-autocomplete v-model="editedItem.difficultylevel" :readonly="editedIndex==-1?false:true" item-text="name" item-value="id" :filled="editedIndex==0?false:true" :error="errorMsg.difficultylevel?true:false" :error-messages="errorMsg.difficultylevel?'Required':''" return-object outlined  chips small-chips :items="diff_level_list"></v-autocomplete>
                                            </v-col>
                                            <v-col cols="12" v-if='editedIndex != -1'>Difficuilty Level
                                                    <v-autocomplete dense v-model="editedItem.difficultylevel" :items="diff_level_list" item-value="id" :error="errorMsg.difficultylevel?true:false" :error-messages="errorMsg.difficultylevel?'Required':''"></v-autocomplete>
                                            </v-col>
                                        </td>
                                        <td>
                                            <v-col>
                                                <ckeditor :editor="editor" v-model="editedItem.question" :config="editorConfig"></ckeditor>
                                            </v-col>
                                        </td>
                                        <td>
                                            <template>
                                                <v-col cols="12" >
                                                   <v-file-input v-model="qfile"  prepend-icon="mdi-attachment" label="Choose File" show-size name="doc"></v-file-input>
                                                </v-col>
                                            </template>
                                        </td>
                                        <td>
                                        <v-col cols="12">
                                            <v-checkbox dense v-model="editedItem.isactive" color="success" label="Is Approve?"></v-checkbox>
                                        </v-col>
                                        </td>
                                    </tr>
                            </tbody>
                    </template>   
                </v-simple-table>
                 <v-row dense>
                    <v-col>
                        <input type="hidden" v-model="editedItem.id" name="id" />
                        <!-- <v-hidden v-model="editedItem.id" label="id"></v-hidden> -->
                    </v-col>
                </v-row>
                <v-toolbar dense color="#f79b07">
                    <b>Please Select Number Of Option</b>
                    <v-col cols="2" sm="2">
                        <select v-model="selected" v-on="enableOption()">
                            <option disabled value="">Please select one</option>
                            <option>3</option>
                            <option>4</option>
                            <option>5</option>
                            </select>
                    </v-col>
                </v-toolbar>
                <br>
                <v-toolbar dense color="#f79b07">
                    <b>Options</b>
                </v-toolbar>
                <br>
                <v-card color="#bae3e8" style="border: 1px solid #bdb7b9;">
                    <v-card-text>
                        <v-row>
                            <v-col cols="2" sm="2">
                                Option A:
                            </v-col>
                            <v-col cols="6" sm="6">
                                <template>
                                    <div id="app">
                                        <ckeditor :editor="editor" v-model="editedItem.option_namea" :config="editorConfig"></ckeditor>
                                    </div>
                                </template>
                            </v-col>
                            <v-col cols="2" sm="2">
                                <template>
                                      <v-file-input v-model="filea"  prepend-icon="mdi-attachment" label="Choose File" show-size name="doc"></v-file-input>
                                </template>
                            </v-col>
                            <v-col cols="2" sm="2">
                                <v-col cols="12">
                                  <input type="radio" id="a" value="a" v-model="picked"><label for="a">Correct Answer</label>
                                </v-col>
                            </v-col>
                        </v-row> 
                        <br>
                        <v-row>
                            <v-col cols="2" sm="2">
                                Option B:
                            </v-col>
                            <v-col cols="6" sm="6">
                                <template>
                                    <div id="app">
                                         <ckeditor :editor="editor" v-model="editedItem.option_nameb" :config="editorConfig"></ckeditor>
                                    </div>
                                </template>
                            </v-col>
                            <v-col cols="2" sm="2">
                                <template>
                                    <v-file-input v-model="fileb"  prepend-icon="mdi-attachment" label="Choose File" show-size name="doc"></v-file-input>
                                </template>
                            </v-col>
                            <v-col cols="2" sm="2">
                                <v-col cols="12">
                                    <input type="radio" id="b" value="b" v-model="picked"><label for="b">Correct Answer</label>
                                </v-col>
                            </v-col>
                        </v-row>
                        <div id='c' style="display:none">
                         <v-row>
                            <v-col cols="2" sm="2"> 
                                Option C:
                            </v-col>
                            <v-col cols="6" sm="6">
                                <template>
                                    <div id="app">
                                        <ckeditor :editor="editor" v-model="editedItem.option_namec" :config="editorConfig"></ckeditor>
                                    </div>
                                </template>
                            </v-col>
                            <v-col cols="2" sm="2">
                                <template>
                                    <v-file-input v-model="filec"  prepend-icon="mdi-attachment" label="Choose File" show-size name="doc"></v-file-input>
                                </template>
                            </v-col>
                            <v-col cols="2" sm="2">
                                <v-col cols="12">
                                   <input type="radio" id="c" value="c" v-model="picked"><label for="c">Correct Answer</label>
                                </v-col>
                            </v-col>
                        </v-row>    
                        </div> 
                        <div id='d' style="display:none">
                         <v-row>
                            <v-col cols="2" sm="2">
                                Option D:
                            </v-col>
                            <v-col cols="6" sm="6">
                                <template>
                                    <div id="app">
                                        <ckeditor :editor="editor" v-model="editedItem.option_named" :config="editorConfig"></ckeditor>
                                    </div>
                                </template>
                            </v-col>
                            <v-col cols="2" sm="2">
                                <template>
                                    <v-file-input v-model="filed" prepend-icon="mdi-attachment" label="Choose File" show-size name="doc"></v-file-input>
                                </template>
                            </v-col>
                            <v-col cols="2" sm="2">
                                <v-col cols="12">
                                    <input type="radio" id="d" value="d" v-model="picked"><label for="d">Correct Answer</label>
                                </v-col>
                            </v-col>
                        </v-row>    
                        </div>   
                        <div id='e' style="display:none">
                         <v-row>
                            <v-col cols="2" sm="2">
                                Option E:
                            </v-col>
                            <v-col cols="6" sm="6">
                                <template>
                                    <div id="app">
                                        <ckeditor :editor="editor" v-model="editedItem.option_namee" :config="editorConfig"></ckeditor>
                                    </div>
                                </template>
                            </v-col>
                            <v-col cols="2" sm="2">
                                <template>
                                    <v-file-input v-model="filee" prepend-icon="mdi-attachment" label="Choose File" show-size name="doc"></v-file-input>
                                </template>
                            </v-col>
                            <v-col cols="2" sm="2">
                                <v-col cols="12">
                                   <input type="radio" id="e" value="e" v-model="picked"><label for="e">Correct Answer</label>
                                </v-col>
                            </v-col>
                        </v-row>    
                        </div>              
                    </v-card-text>
                </v-card>
             </v-container>
            

               <v-btn color="primary darken-1" @click="save">Save</v-btn>
              
         </v-card-text>
          <ckeditor :editor="editor" v-model="message" :config="editorConfig"></ckeditor>
           <p>Message is: {{ message }}</p>
           <input v-model="message1" placeholder="edit me">
           <p>Message is: {{ message1 }}</p>
    </div>
</template>
<script src="https://wiris.net/demo/plugins/app/WIRISplugins.js?viewer=image"></script>
<script>
    import axios from "axios";
    CKEDITOR.plugins.addExternal('ckeditor_wiris', 'https://www.wiris.net/demo/plugins/ckeditor/', 'plugin.js');

    export default {
        data: () => ({
            errorMsg: {
                unit: false,
                questiontype : false,
                difficultylevel: false
            },
            
            editorConfig: {
                    // The configuration of the editor.
                    extraPlugins: 'ckeditor_wiris',
                    allowedContent : true,
                   // mathJaxLib: 'http://cdn.mathjax.org/mathjax/2.6-latest/MathJax.js?config=TeX-AMS_HTML',
                },
                message:'',
                message1:'hello how',
            snackbar_msg: "",
            color: "",
            snackbar: false,
            search: "",
            qno:'',
            load: false,
            dialog: false,
            question_list: null,
            unit_list: null,
            question_type_list: null,
            diff_level_list: null,
            courseinfo:null,
            qttype:null,
            qfile:null,
            filea:null,
            fileb:null,
            filec:null,
            filed:null,
            filee:null,
            picked:'',
            option_namea:"",
            option_nameb:"",
            option_namec:"",
            option_named:"",
            option_namee:"",
            course_id:'',
            selected:'',
            headers: [{
                text:"Question No.", 
                value:"qno"
            },
            {
                text: "Unit No.",
                value: "unit"
            }, {
                text: "Difficulty Type",
                value: "difficultylevel"
            },
            {
                text: "Question Type",
                value: "questiontype"
            },  
            {
                 text: "Question Statement",
                value: "question"
            },
            {
                text: "Option",
                value: "option_name" 
            },
            {
                 text: "Weightage",
                value: "weightage"
            },
            {
                text: "Is Approve",
                value: "isactive"
            },
             ],

            editedIndex: -1,
            editedItem: {
                id: '',
                unit: '',
                questiontype: "",
                difficultylevel: "",
                question:"",
                qno:"",
                weightage:"",
                isactive: true,
              
                //option field
                 picked:'',
                option_value:"",
                option_namea:"",
                option_nameb:"",
                option_namec:"",
                option_named:"",
                option_namee:"",
                qfile:null,
                filea:null,
                fileb:null,
                filec:null,
                filed:null,
                filee:null,

                
            },
            defaultItem: {
                id: '',
                unit: "",
                questiontype : "",
                difficultylevel: "",
                question:"",
                qno:"",
                weightage:"",
                isactive: true,
              
                 //option field
                 picked:'',
                qfile:null,
                filea:null,
                fileb:null,
                filec:null,
                filed:null,
                filee:null,
                option_value:"",
                option_namea:"",
                option_nameb:"",
                option_namec:"",
                option_named:"",
                option_namee:"",
               
            }
        }),
        updated: function () {	
                console.log("Inside updated")	
                this.$nextTick(function () {
                    CKEDITOR.plugins.addExternal('ckeditor_wiris', 'https://www.wiris.net/demo/plugins/ckeditor/', 'plugin.js');
                MathLive.renderMathInDocument();	
        })
	    //MathLive.makeMathField('mathfield');	
	    // Code that will run only after the	
	    // entire view has been re-rendered	
	 	
	},
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New  Question" : "Edit Question";
            }
        },

        watch: {
            dialog(val) {
                val || this.close();
            }
        },
        mounted() {
           
            const data={
                crs_id:this.$store.getters.courseid,
                qtypeid:this.$store.getters.qbankquestype,
                mess:'test',
            };
            axios
                .post("/Qbank/addQuestion",data)
                .then(res => { 
                    if (res.data.msg == "200") {
                     
                        this.courseinfo = res.data.crsinfo
                        this.question_list = res.data.question_list;
                        this.unit_list = res.data.unitno;
                        this.question_type_list = res.data.question_type_list
                        this.diff_level_list = res.data.difficultylevel;
                        this.qttype = res.data.questionType;
                        this.qno = res.data.qno;
                        this.load = true;
                    } else {}
                })
                .catch(error => {
                    window.console.log(error);
                });
        },

        methods: {
            initializeErrorMsgFalse() {
                    this.errorMsg.unit = false;
                    this.errorMsg.questiontype = false;
                    this.errorMsg.difficultylevel = false;
                },
                showSnackbar(clr, msg) {
                    this.snackbar = true;
                    this.color = clr;
                    this.snackbar_msg = msg;
                },
                editItem(item) {
                    this.editedIndex = this.question_list.indexOf(item);
                    this.editedItem = Object.assign({}, item);
                    this.dialog = true;
                },
                enableOption()
                {
                    switch (this.selected) 
                    {
                        case '3':
                            var opc = document.getElementById("c");
                            var opd = document.getElementById("d");
                            var ope = document.getElementById("e");
                            opc.style.display = "block";
                            opd.style.display = "none";
                            ope.style.display = "none";
                            break;
                        case '4':
                            var opc = document.getElementById("c");
                            var opd = document.getElementById("d");
                            var ope = document.getElementById("e");
                            opc.style.display = "block";
                            opd.style.display = "block";
                            ope.style.display = "none";
                            break;
                        case '5':
                            var opc = document.getElementById("c");
                            var opd = document.getElementById("d");
                            var ope = document.getElementById("e");
                            opc.style.display = "block";
                            opd.style.display = "block";
                            ope.style.display = "Block";
                            break;
                    }
                    
                },
                viewQuesBank()
                {
                    alert('view question bank');
                    this.$router.push("/instructor-question-view") 
                },
                close() {
                    this.dialog = false;
                    this.initializeErrorMsgFalse();
                    setTimeout(() => {
                        this.editedItem = Object.assign({}, this.defaultItem);
                        this.editedIndex = -1;
                    }, 300);
                },

                save() {
                    let formData = new FormData();
                      
                    formData.append("qfile", this.qfile)
                    formData.append("question", this.editedItem.question)  
                   
                    formData.append("filea", this.filea)
                    formData.append("optiona", this.editedItem.option_namea)

                    formData.append("fileb", this.fileb)
                    formData.append("optionb", this.editedItem.option_nameb)

                    formData.append("filec", this.filec)
                    formData.append("optionc", this.editedItem.option_namec)

                    formData.append("filed", this.filed)
                    formData.append("optiond", this.editedItem.option_named)

                    formData.append("filee", this.filee)
                    formData.append("optione", this.editedItem.option_namee)

                    formData.append("iscorrect", this.picked)
                    formData.append("qno", this.qno)
                    formData.append("qtype", this.qttype.id)
                    formData.append("crsid", this.courseinfo.crsid)
                    formData.append("qapprove", this.editedItem.isactive)
                    formData.append("unitid", this.editedItem.unit.id)
                     formData.append("difficultyid", this.editedItem.difficultylevel.id)
                     formData.append("message", this.message)


                    console.log(formData)
                    if (this.editedIndex > -1) {
                        if (this.isValidated()) {
                             console.log("edit.." + this.editedItem);

                            axios
                                .post("/Qbank/saveQuestion", 
                                formData,
                                    {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                       
                                    }
                                }
                                )
                                .then(res => {
                                    if (res.data.msg == "200") {
                                        Object.assign(
                                            this.question_list[this.editedIndex],
                                            this.editedItem,
                                            this.qno= res.data.qno,
                                            this.picked=''
                                        );
                                        this.showSnackbar(
                                            "#4caf50",
                                            "Question Successfully..."
                                           
                                        ); // show snackbar on success
                                      
                                    }
                                })
                                .catch(error => {
                                    window.console.log(error);
                                });

                            this.close();
                        }
                    } else {
                        
                        if (this.isValidated()) {
                            axios
                                .post("Qbank/saveQuestion",formData,
                                    {
                                    headers: {
                                        'Content-Type': 'multipart/form-data'
                                    }
                                }
                                ).then(res => {
                                    if (res.data.status.code == "SUCCESS") {
                                        this.qno= res.data.qno;
                                         this.picked='';
                                         this.qfile=null;
                                         this.filea=null;
                                         this.fileb=null;
                                         this.filec=null;
                                         this.filed=null;
                                         this.filee=null;
                                        this.showSnackbar(
                                            "#4caf50",
                                            " Question Added Successfully..."
                                        ); // show snackbar on success
                                    } else if (res.data.status.code == "NA") {
                                        this.showSnackbar(
                                            "#b71c1c",
                                            " Question Already Present!!!"
                                        ); // show snackbar on error
                                    }
                                })
                                .catch(error => {
                                    window.console.log(error);
                                });

                            this.close();
                        }
                    }
                }, // end of save()

                isValidated() {
                    if (this.editedItem.unit && this.editedItem.difficultylevel ) {
                        return true;
                    } else {
                        if (!this.editedItem.unit) {
                            this.errorMsg.unit = true;
                        }
                        if (!this.editedItem.adifficultylevely) {
                            this.errorMsg.difficultylevel = true;
                        }
                       
                        return false;
                    }
                }
        }
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    
    .v-icon-size {
        font-size: 20px;
    }
    
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    
    .edit-v-icon:hover {
        color: white;
    }
</style>
      